<template src="./paladin-report-edit.html"></template>

<script>
import { ChiRhosNext } from "@paladin/core";

import _ from "lodash";
import Multiselect from "vue-multiselect";
import PaladinPersonLookup from "../personlookup/paladin-person-lookup";
import PaladinFilterSet from "../filterset/paladin-filterset";
import * as PropertyOptions from "../../exports/propertyOptions";

const ChiRhosNextApi = new ChiRhosNext().api();

export default {
  components: { Multiselect, PaladinPersonLookup, PaladinFilterSet },
  props: {
    activeGroup: {
      type: Object,
      default: null
    },
    activeGroupType: {
      type: Object,
      default: null
    },
    reportData: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      running: false,
      isCancelled: false,
      groupTypes: [],
      reportTypeOptions: [
        {
          text: "Events",
          description:
            "Event reports are used to analyse the events that happened. You can count events or use sum and average on properties of events. In an event report, the main filter will filter the events you want to report on, and the aggregates (sum, count, average) are also on events. If you use Split, then the results will be split by the group that the event is within (it might be belong to the group itself or one of it's descendants).",
          value: "events",
          filter: "event",
          propertyFilter: "event",
          disabled: false,
          intervalOptions: [
            {
              text: "Day",
              value: "day"
            },
            {
              text: "Week",
              value: "week"
            },
            {
              text: "Month",
              value: "month"
            },
            {
              text: "Year",
              value: "year"
            },
            {
              text: "Event",
              value: "event"
            }
          ],
          report: reportConstruct => {
            ChiRhosNextApi.EventApi.eventRunReport(reportConstruct).then(
              response => {
                this.returnReport(response.dataPoints);
                this.running = false;
              },
              error => {
                console.error(error);
                error.json().then(body => {
                  this.$toast(body.Message, "error");
                });
                this.running = false;
                this.isCancelled = false;
              }
            );
          },
          save: reportConstruct => {
            if (this.activeGroup) {
              ChiRhosNextApi.EventApi.eventSaveReport(reportConstruct).then(
                response => {
                  this.refreshSavedReports();
                  this.$toast("Report saved", "success");
                },
                error => {
                  console.error(error);
                  error.json().then(body => {
                    this.$toast(body.Message, "error");
                  });
                }
              );
            } else {
              ChiRhosNextApi.EventApi.eventSaveReportForGroupType(
                reportConstruct
              ).then(
                response => {
                  this.refreshSavedReports();
                  this.$toast("Report saved to group type", "success");
                },
                error => {
                  console.error(error);

                  error.json().then(body => {
                    this.$toast(body.Message, "error");
                  });
                }
              );
            }
          },
          delete: reportEntityId => {
            {
              ChiRhosNextApi.EventApi.eventDeleteReport(reportEntityId).then(
                response => {
                  this.refreshSavedReports();
                  this.$toast("Report deleted", "success");
                },
                error => {
                  console.error(error);
                  error.json().then(body => {
                    this.$toast(body.Message, "error");
                  });
                }
              );
            }
          },
          saved: () => {
            if (this.activeGroup) {
              ChiRhosNextApi.EventApi.eventListReport({
                entityId: this.activeGroup.entity.entityId
              }).then(
                response => {
                  this.saved = response.data ? response.data : [];
                },
                error => {
                  console.error(error);
                  error.json().then(body => {
                    this.$toast(body.Message, "error");
                  });
                }
              );
            } else {
              ChiRhosNextApi.EventApi.eventListReportForGroupType({
                entityId: this.computedEntityTypeId
              }).then(
                response => {
                  this.saved = response.data ? response.data : [];
                },
                error => {
                  console.error(error);
                  error.json().then(body => {
                    this.$toast(body.Message, "error");
                  });
                }
              );
            }
          }
        },
        {
          text: "Event Attendance",
          description:
            "Event Attendance reports are used to analyse the attendance for events. The main filter will filter the Events you want to report on, and the aggregates (sum, count, average) are done on the Event Attendance record. If you use Split, then the results will be split by the group that the attendees is a member of (it might be belong to the group itself or one of it's descendants). Note that this means a person may be counted twice or more times if they are a member of more than one group in the split.",
          value: "event-attendance",
          filter: "event",
          propertyFilter: "eventAttendance",
          disabled: false,
          intervalOptions: [
            {
              text: "Day",
              value: "day"
            },
            {
              text: "Week",
              value: "week"
            },
            {
              text: "Month",
              value: "month"
            },
            {
              text: "Year",
              value: "year"
            },
            {
              text: "Event",
              value: "event"
            }
          ],
          report: reportConstruct => {
            ChiRhosNextApi.EventApi.attendRunReport(reportConstruct).then(
              response => {
                this.returnReport(response.dataPoints);
                this.running = false;
              },
              error => {
                console.error(error);
                error.json().then(body => {
                  this.$toast(body.Message, "error");
                });
                this.running = false;
                this.isCancelled = false;
              }
            );
          },
          save: reportConstruct => {
            if (this.activeGroup) {
              ChiRhosNextApi.EventApi.attendSaveReport(reportConstruct).then(
                response => {
                  this.refreshSavedReports();
                  this.$toast("Report saved", "success");
                },
                error => {
                  console.error(error);
                  error.json().then(body => {
                    this.$toast(body.Message, "error");
                  });
                }
              );
            } else {
              ChiRhosNextApi.EventApi.attendSaveReportForGroupType(
                reportConstruct
              ).then(
                response => {
                  this.refreshSavedReports();
                  this.$toast("Report saved to group type", "success");
                },
                error => {
                  console.error(error);
                  error.json().then(body => {
                    this.$toast(body.Message, "error");
                  });
                }
              );
            }
          },
          delete: reportEntityId => {
            {
              ChiRhosNextApi.EventApi.attendDeleteReport(reportEntityId).then(
                response => {
                  this.refreshSavedReports();
                  this.$toast("Report deleted", "success");
                },
                error => {
                  console.error(error);
                  error.json().then(body => {
                    this.$toast(body.Message, "error");
                  });
                }
              );
            }
          },
          saved: () => {
            if (this.activeGroup) {
              ChiRhosNextApi.EventApi.attendListReport({
                entityId: this.activeGroup.entity.entityId
              }).then(
                response => {
                  this.saved = response.data ? response.data : [];
                },
                error => {
                  console.error(error);
                  error.json().then(body => {
                    this.$toast(body.Message, "error");
                  });
                }
              );
            } else {
              ChiRhosNextApi.EventApi.attendListReportForGroupType({
                entityId: this.computedEntityTypeId
              }).then(
                response => {
                  this.saved = response.data ? response.data : [];
                },
                error => {
                  console.error(error);
                  error.json().then(body => {
                    this.$toast(body.Message, "error");
                  });
                }
              );
            }
          }
        },
        {
          text: "Event Absence",
          description:
            "Event Absence reports are used to analyse absence for events. The main filter will filter the Events you want to report on, and the aggregates (sum, count, average) are done on the Person records. Note that this only lists invited attendees with NO attendance record (even declined RSVP). To count these, use an Event Attendance report. If you use Split, then the results will be split by the group that the attendees is a member of (it might be belong to the group itself or one of it's descendants). Note that this means a person may be counted twice or more times if they are a member of more than one group in the split.",
          value: "event-absence",
          filter: "event",
          propertyFilter: "person",
          disabled: false,
          intervalOptions: [
            {
              text: "Event",
              value: "event"
            }
          ],
          report: reportConstruct => {
            ChiRhosNextApi.EventApi.attendAbsentRunReport(reportConstruct).then(
              response => {
                this.returnReport(response.dataPoints);
                this.running = false;
              },
              error => {
                console.error(error);
                error.json().then(body => {
                  this.$toast(body.Message, "error");
                });
                this.running = false;
                this.isCancelled = false;
              }
            );
          },
          save: reportConstruct => {
            if (this.activeGroup) {
              ChiRhosNextApi.EventApi.attendAbsentSaveReport(
                reportConstruct
              ).then(
                response => {
                  this.refreshSavedReports();
                  this.$toast("Report saved", "success");
                },
                error => {
                  console.error(error);
                  error.json().then(body => {
                    this.$toast(body.Message, "error");
                  });
                }
              );
            } else {
              ChiRhosNextApi.EventApi.attendAbsentSaveReportForGroupType(
                reportConstruct
              ).then(
                response => {
                  this.refreshSavedReports();
                  this.$toast("Report saved to group type", "success");
                },
                error => {
                  console.error(error);
                  error.json().then(body => {
                    this.$toast(body.Message, "error");
                  });
                }
              );
            }
          },
          delete: reportEntityId => {
            {
              ChiRhosNextApi.EventApi.attendAbsentDeleteReport(
                reportEntityId
              ).then(
                response => {
                  this.refreshSavedReports();
                  this.$toast("Report deleted", "success");
                },
                error => {
                  console.error(error);
                  error.json().then(body => {
                    this.$toast(body.Message, "error");
                  });
                }
              );
            }
          },
          saved: () => {
            if (this.activeGroup) {
              ChiRhosNextApi.EventApi.attendAbsentListReport({
                entityId: this.activeGroup.entity.entityId
              }).then(
                response => {
                  this.saved = response.data ? response.data : [];
                },
                error => {
                  console.error(error);
                  error.json().then(body => {
                    this.$toast(body.Message, "error");
                  });
                }
              );
            } else {
              ChiRhosNextApi.EventApi.attendAbsentListReportForGroupType({
                entityId: this.computedEntityTypeId
              }).then(
                response => {
                  this.saved = response.data ? response.data : [];
                },
                error => {
                  console.error(error);
                  error.json().then(body => {
                    this.$toast(body.Message, "error");
                  });
                }
              );
            }
          }
        },
        {
          text: "Groups",
          description:
            "Group reports are used to analyse the groups in your organisation. You can count groups or use sum and average on properties of groups. In a group report, the main filter will filter the groups you want to report on, and the aggregates (sum, count, average) are also on groups. If you use Split, then the results will be split by the group and descendants.",
          value: "groups",
          filter: "group",
          propertyFilter: "group",
          disabled: false,
          intervalOptions: [
            {
              text: "Day",
              value: "day"
            },
            {
              text: "Week",
              value: "week"
            },
            {
              text: "Month",
              value: "month"
            },
            {
              text: "Year",
              value: "year"
            }
          ],
          report: reportConstruct => {
            ChiRhosNextApi.GroupApi.groupRunReport(reportConstruct).then(
              response => {
                this.returnReport(response.dataPoints);
                this.running = false;
              },
              error => {
                console.error(error);
                error.json().then(body => {
                  this.$toast(body.Message, "error");
                });
                this.running = false;
                this.isCancelled = false;
              }
            );
          },
          save: reportConstruct => {
            if (this.activeGroup) {
              ChiRhosNextApi.GroupApi.groupSaveReport(reportConstruct).then(
                response => {
                  this.refreshSavedReports();
                  this.$toast("Report saved", "success");
                },
                error => {
                  console.error(error);
                  error.json().then(body => {
                    this.$toast(body.Message, "error");
                  });
                }
              );
            } else {
              ChiRhosNextApi.GroupApi.groupSaveReportForGroupType(
                reportConstruct
              ).then(
                response => {
                  this.refreshSavedReports();
                  this.$toast("Report saved to group type", "success");
                },
                error => {
                  console.error(error);
                  error.json().then(body => {
                    this.$toast(body.Message, "error");
                  });
                }
              );
            }
          },
          delete: reportEntityId => {
            {
              ChiRhosNextApi.GroupApi.groupDeleteReport(reportEntityId).then(
                response => {
                  this.refreshSavedReports();
                  this.$toast("Report deleted", "success");
                },
                error => {
                  console.error(error);
                  error.json().then(body => {
                    this.$toast(body.Message, "error");
                  });
                }
              );
            }
          },
          saved: () => {
            if (this.activeGroup) {
              ChiRhosNextApi.GroupApi.groupListReport({
                entityId: this.activeGroup.entity.entityId
              }).then(
                response => {
                  this.saved = response.data ? response.data : [];
                },
                error => {
                  console.error(error);
                  error.json().then(body => {
                    this.$toast(body.Message, "error");
                  });
                }
              );
            } else {
              ChiRhosNextApi.GroupApi.groupListReportForGroupType({
                entityId: this.computedEntityTypeId
              }).then(
                response => {
                  this.saved = response.data ? response.data : [];
                },
                error => {
                  console.error(error);
                  error.json().then(body => {
                    this.$toast(body.Message, "error");
                  });
                }
              );
            }
          }
        },
        {
          text: "Membership",
          description:
            "Membership reports are used to analyse the members of groups in your organisation. You can count members or use sum and average on properties of members. In a membership report, the main filter will filter the roles you want to report on, and the aggregates (sum, count, average) work with the members of those groups. If you use Split, then the results will be split by the group that the member belongs to (the group might be part of the split itself or one of it's descendants). Note that this means a person may be counted twice or more times if they are a member of more than one group in the split.",
          value: "membership",
          filter: "role",
          propertyFilter: "person",
          disabled: false,
          intervalOptions: [
            {
              text: "Day",
              value: "day"
            },
            {
              text: "Week",
              value: "week"
            },
            {
              text: "Month",
              value: "month"
            },
            {
              text: "Year",
              value: "year"
            }
          ],
          report: reportConstruct => {
            ChiRhosNextApi.PersonApi.membershipRunReport(reportConstruct).then(
              response => {
                this.returnReport(response.dataPoints);
                this.running = false;
              },
              error => {
                console.error(error);
                error.json().then(body => {
                  this.$toast(body.Message, "error");
                });
                this.running = false;
                this.isCancelled = false;
              }
            );
          },
          save: reportConstruct => {
            if (this.activeGroup) {
              ChiRhosNextApi.PersonApi.membershipSaveReport(
                reportConstruct
              ).then(
                response => {
                  this.refreshSavedReports();
                  this.$toast("Report saved", "success");
                },
                error => {
                  console.error(error);
                  error.json().then(body => {
                    this.$toast(body.Message, "error");
                  });
                }
              );
            } else {
              ChiRhosNextApi.PersonApi.membershipSaveReportForGroupType(
                reportConstruct
              ).then(
                response => {
                  this.refreshSavedReports();
                  this.$toast("Report saved to group type", "success");
                },
                error => {
                  console.error(error);
                  error.json().then(body => {
                    this.$toast(body.Message, "error");
                  });
                }
              );
            }
          },
          delete: reportEntityId => {
            {
              ChiRhosNextApi.PersonApi.membershipDeleteReport(
                reportEntityId
              ).then(
                response => {
                  this.refreshSavedReports();
                  this.$toast("Report deleted", "success");
                },
                error => {
                  console.error(error);
                  error.json().then(body => {
                    this.$toast(body.Message, "error");
                  });
                }
              );
            }
          },
          saved: () => {
            if (this.activeGroup) {
              ChiRhosNextApi.PersonApi.membershipListReport({
                entityId: this.activeGroup.entity.entityId
              }).then(
                response => {
                  this.saved = response.data ? response.data : [];
                },
                error => {
                  console.error(error);
                  error.json().then(body => {
                    this.$toast(body.Message, "error");
                  });
                }
              );
            } else {
              ChiRhosNextApi.PersonApi.membershipListReportForGroupType({
                entityId: this.computedEntityTypeId
              }).then(
                response => {
                  this.saved = response.data ? response.data : [];
                },
                error => {
                  console.error(error);
                  error.json().then(body => {
                    this.$toast(body.Message, "error");
                  });
                }
              );
            }
          }
        }
      ],
      reportForm: {
        //        filter: null,
        name: "",
        belongsTo: null,
        type: null,
        includeChildren: false,
        limitChildrenGroupTypes: [],
        from: null,
        to: null,
        interval: null,
        // aggregate: {
        //   type: null,
        //   property: null,
        //   itemKey: null
        // },
        aggregates: [],
        splitByGroupTypeEntityId: "00000000-0000-0000-0000-000000000000"
      },
      saved: [],
      existing: null
    };
  },
  computed: {
    propertyOptions: function() {
      return PropertyOptions.propertyOptions;
    },
    groupTypeOptions: function() {
      return this.groupTypes.map(item => {
        return {
          value: item.entity.entityId,
          text: item.entity.name
        };
      });
    },
    computedAggregatePropertyOptions: function() {
      if (
        this.propertyOptions[this.selectedReportType.propertyFilter] &&
        this.propertyOptions[this.selectedReportType.propertyFilter].filter(
          o => o.type === Number
        ).length > 0
      ) {
        return this.propertyOptions[
          this.selectedReportType.propertyFilter
        ].filter(o => o.type === Number);
      } else {
        return [];
      }
    },
    computedAggregateTypeOptions: function() {
      if (
        this.propertyOptions[this.selectedReportType.filter] &&
        this.propertyOptions[this.selectedReportType.filter].filter(
          o => o.type === Number
        ).length > 0
      ) {
        return [
          {
            text: "Sum",
            value: "sum"
          },
          {
            text: "Count",
            value: "count"
          },
          {
            text: "Average",
            value: "average"
          }
        ];
      } else {
        return [
          {
            text: "Count",
            value: "count"
          }
        ];
      }
    },
    computedEntityTypeId: function() {
      if (this.activeGroup) {
        return this.activeGroup.entity.type;
      } else {
        // group type
        return this.activeGroupType.entity.entityId;
      }
    },
    selectedReportType() {
      if (this.reportForm.type) {
        return this.reportTypeOptions.find(op => {
          return op.value === this.reportForm.type;
        });
      }

      return null;
    },
    savedOptions: function() {
      if (this.saved) {
        return this.saved.map(item => {
          return {
            value: item.entity.entityId,
            text: item.entity.name
          };
        });
      } else {
        return [];
      }
    }
  },
  watch: {
    activeGroup: function(val) {
      this.refreshSavedReports();
    },
    activeGroupType: function(val) {
      this.refreshSavedReports();
    }
  },
  created: function() {},
  mounted() {
    this.$nextTick(function() {
      this.init();
    });
  },
  methods: {
    init() {
      ChiRhosNextApi.GroupTypeApi.listDescendantGroupTypes({
        entityId: this.computedEntityTypeId
      }).then(
        response => {
          this.groupTypes = response.data;
        },
        error => {
          console.error(error);
          error.json().then(body => {
            this.$toast(body.Message, "error");
          });
        }
      );
    },
    refreshSavedReports() {
      if (this.selectedReportType) {
        this.selectedReportType.saved();
      } else {
        this.saved = [];
      }
    },
    loadReport() {
      this.resetForm();

      // extra resetting

      this.reportForm.interval = null;
      this.reportForm.includeChildren = false;
      this.reportForm.splitByGroupTypeEntityId =
        "00000000-0000-0000-0000-000000000000";
      this.reportForm.limitChildrenGroupTypes = [];

      var item = this.saved.find(op => {
        return op.entity.entityId === this.existing;
      });

      if (item) {
        let _existing = item.entity;

        this.reportForm.name = _existing.name;
        this.reportForm.interval = _existing.interval;
        this.reportForm.from = _existing.from
          ? _existing.from.substring(0, 10)
          : "";
        this.reportForm.to = _existing.to ? _existing.to.substring(0, 10) : "";
        this.reportForm.includeChildren = _existing.includeChildren;
        this.reportForm.splitByGroupTypeEntityId =
          _existing.splitByGroupTypeEntityId;
        if (_existing.limitChildrenGroupTypes) {
          let _groupTypeOptions = this.groupTypeOptions;
          let _limitChildrenGroupTypes = this.reportForm
            .limitChildrenGroupTypes;

          _existing.limitChildrenGroupTypes.forEach(function(value) {
            var option = _groupTypeOptions.find(op => {
              return op.value === value;
            });

            if (option) _limitChildrenGroupTypes.push(option);
          });
        }
        let _reportForm = this.reportForm;
        let _generateUUID = this.generateUUID;

        if (_existing.aggregates) {
          let _getPropertyControlType = this.getPropertyControlType;
          let _setAdd = this.setAdd;

          _existing.aggregates.forEach(function(aggregate, index) {
            aggregate.filterPreset = aggregate.filter
              ? _.clone(aggregate.filter, true)
              : null;

            let agg = _setAdd(aggregate.filter);

            if (aggregate.count) {
              aggregate.count.forEach(function(value) {
                agg.aggregates.push({
                  id: _generateUUID(),
                  type: "count",
                  controlType: _getPropertyControlType(value.property),
                  property: value.property,
                  filter: value.filter,
                  filterPreset: value.filter
                    ? _.clone(value.filter, true)
                    : null
                });
              });
            }
            if (aggregate.sum) {
              aggregate.sum.forEach(function(value) {
                agg.aggregates.push({
                  id: _generateUUID(),
                  type: "sum",
                  controlType: _getPropertyControlType(value.property),
                  property: value.property,
                  filter: value.filter,
                  filterPreset: value.filter
                    ? _.clone(value.filter, true)
                    : null
                });
              });
            }
            if (aggregate.average) {
              aggregate.average.forEach(function(value) {
                agg.aggregates.push({
                  id: _generateUUID(),
                  type: "average",
                  controlType: _getPropertyControlType(value.property),
                  property: value.property,
                  filter: value.filter,
                  filterPreset: value.filter
                    ? _.clone(value.filter, true)
                    : null
                });
              });
            }
          });
        } else {
          this.setAdd(null); // add an initial set
        }

        //        this.reportForm.filter = _existing.filter
        // if (_existing.count) {
        //   _existing.count.forEach(function(value) {
        //     _reportForm.aggregates.push({
        //       id: _generateUUID(),
        //       type: "count",
        //       property: value.property,
        //       filter: value.filter
        //     })
        //   })
        // }
        // if (_existing.sum) {
        //   _existing.sum.forEach(function(value) {
        //     _reportForm.aggregates.push({
        //       id: _generateUUID(),
        //       type: "sum",
        //       property: value.property,
        //       filter: value.filter
        //     })
        //   })
        // }
        // if (_existing.average) {
        //   _existing.average.forEach(function(value) {
        //     _reportForm.aggregates.push({
        //       id: _generateUUID(),
        //       type: "average",
        //       property: value.property,
        //       filter: value.filter
        //     })
        //   })
        // }
      }
    },
    resetType() {
      this.resetForm();

      this.setAdd(null); // add an initial set

      this.existing = null;
      this.saved = [];

      this.refreshSavedReports();
    },
    resetForm() {
      this.reportForm.name = "";
      // this.reportForm.filter = null
      // this.reportForm.aggregate.type = null
      // this.reportForm.aggregate.property = null
      // this.reportForm.aggregate.itemKey = null

      // clear cleanly so that the components pop nicely
      while (this.reportForm.aggregates.length) {
        this.reportForm.aggregates.pop();
      }
    },
    getPropertyControlType: function(prop) {
      if (this.propertyOptions[this.selectedReportType.propertyFilter]) {
        var item = this.propertyOptions[
          this.selectedReportType.propertyFilter
        ].find(op => {
          return op.value === prop;
        });

        if (item) return item.controlType;
      }

      return null;
    },
    setControlType: function(agg) {
      agg.controlType = this.getPropertyControlType(agg.property);
    },
    setRemove: function(agg) {
      this.reportForm.aggregates = _.remove(
        this.reportForm.aggregates,
        function(element) {
          return element.id !== agg.id;
        }
      );

      this.reportForm.aggregates.forEach(function(aggregate, index) {
        aggregate.title = "Set " + (index + 1);
      });
    },
    setAdd: function(filter) {
      var setItem = {
        title: "Set " + (this.reportForm.aggregates.length + 1),
        id: this.generateUUID(),
        filter: filter,
        aggregate: {
          type: null,
          controlType: null,
          property: null,
          itemKey: null
        },
        aggregates: []
      };

      this.reportForm.aggregates.push(setItem);

      return setItem;
    },
    upperCaseFirst(text) {
      return (
        text
          .toString()
          .charAt(0)
          .toUpperCase() + text.slice(1)
      );
    },
    getFilterPropertyName(property) {
      var item = this.propertyOptions[this.selectedReportType.filter].find(
        op => {
          return op.value === property;
        }
      );

      if (item) {
        return item.text;
      }

      return property;
    },
    addAggregate(agg) {
      let property = agg.aggregate.property;

      if (
        this.getPropertyControlType(property) === "dictionary~number" &&
        !agg.aggregate.itemKey
      ) {
        this.$toast(
          "You must choose an item key for the aggregate as it is a number dictionary",
          "error"
        );
        return;
      }

      if (agg.aggregate.itemKey) property += ":" + agg.aggregate.itemKey;

      agg.aggregates.push({
        id: this.generateUUID(),
        type: agg.aggregate.type,
        property: property,
        filter: null
      });

      agg.aggregate.type = null;
      agg.aggregate.property = null;
      agg.aggregate.itemKey = null;
    },
    generateUUID() {
      // Public Domain/MIT https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
      var d = new Date().getTime(); // Timestamp
      var d2 =
        (performance && performance.now && performance.now() * 1000) || 0; // Time in microseconds since page-load or 0 if unsupported
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(
        c
      ) {
        var r = Math.random() * 16; // random number between 0 and 16
        if (d > 0) {
          // Use timestamp until depleted
          r = (d + r) % 16 | 0;
          d = Math.floor(d / 16);
        } else {
          // Use microseconds since page-load if supported
          r = (d2 + r) % 16 | 0;
          d2 = Math.floor(d2 / 16);
        }
        return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
      });
    },
    updateAggregateFilter(agg, id, evt) {
      if (agg.aggregates) {
        var item = agg.aggregates.find(op => {
          return op.id === id;
        });

        if (item) {
          item.filter = evt;
        }
      }
    },
    removeAggregateFilter(agg, id) {
      if (agg.aggregates) {
        var item = agg.aggregates.find(op => {
          return op.id === id;
        });

        if (item) {
          agg.aggregates.splice(agg.aggregates.indexOf(item), 1);
        }
      }
    },
    runReport(evt) {
      evt.preventDefault();

      if (this.isCancelled) {
        this.$toast(
          "The last report is still being cancelled, please wait before retrying",
          "error"
        );
        return;
      }

      this.isCancelled = false;
      this.running = true;
      this.selectedReportType.report(this.createReportConstruct());
    },
    deleteReport() {
      this.selectedReportType.delete(this.existing);

      this.existing = null;
    },
    createReportConstruct() {
      let _reportConstruct = {};

      _reportConstruct.name = this.reportForm.name;
      if (this.activeGroup) {
        _reportConstruct.belongsTo = this.activeGroup.entity.entityId;
      } else {
        _reportConstruct.belongsTo = this.computedEntityTypeId;
      }
      _reportConstruct.from = this.reportForm.from;
      _reportConstruct.to = this.reportForm.to;
      _reportConstruct.includeChildren = this.reportForm.includeChildren;
      _reportConstruct.splitByGroupTypeEntityId = this.reportForm.splitByGroupTypeEntityId;
      _reportConstruct.limitChildrenGroupTypes = this.reportForm
        .limitChildrenGroupTypes
        ? this.reportForm.limitChildrenGroupTypes.map(item => {
            return item.value;
          })
        : [];
      _reportConstruct.interval = this.reportForm.interval;

      _reportConstruct.aggregates = [];

      if (this.reportForm.aggregates) {
        this.reportForm.aggregates.forEach(function(aggregate) {
          var agg = {};

          agg.filter = aggregate.filter;
          agg.count = aggregate.aggregates.filter(a => a.type === "count");
          agg.sum = aggregate.aggregates.filter(a => a.type === "sum");
          agg.average = aggregate.aggregates.filter(a => a.type === "average");

          _reportConstruct.aggregates.push(agg);
        });
      }

      return _reportConstruct;
    },
    updateFilter(agg, filter) {
      agg.filter = filter;
    },
    saveAsReport() {
      this.existing = null;

      this.saveReport();
    },
    saveReport() {
      if (!this.reportForm.type) {
        this.$toast(
          "You must choose a report type before you can save it",
          "error"
        );
        return;
      }

      if (!this.reportForm.name) {
        this.$toast(
          "You must choose a report name before you can save it",
          "error"
        );
        return;
      }

      let _reportConstruct = this.createReportConstruct();

      if (this.existing) _reportConstruct.entityId = this.existing;

      this.selectedReportType.save(_reportConstruct);
    },
    returnReport(report) {
      if (this.isCancelled) {
        this.isCancelled = false;
      } else {
        this.$emit("executed", report);
      }
    },
    cancelRunning() {
      this.running = false;
      this.isCancelled = true;
    }
  }
};
</script>

<style lang="scss"></style>
